"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartileButtonsContainer = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const StyledCartileButtonWrapper = components_core_1.styled.div `
  margin-top: ${props => (props.index !== 0 ? props.theme.size.static200 : 0)};
`;
function CartileButtonsContainer({ children }) {
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.Children.map(children, (child, index) => (react_1.default.createElement(StyledCartileButtonWrapper, { index: index }, child)))));
}
exports.CartileButtonsContainer = CartileButtonsContainer;
